var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "actions-collapsed-list" },
    [
      _c(
        "a",
        {
          staticClass: "btn btn-function exit-collapsed-list",
          on: { click: _vm.collapseActions }
        },
        [
          _c("i", {
            staticClass: "glyphicon glyphicon-chevron-left",
            attrs: {
              "aria-hidden": "true",
              "tooltip-placement": "right",
              "uib-tooltip": "Cancel"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "action-icon" }, [
        _c(
          "a",
          {
            staticClass: "btn btn-list-function",
            attrs: { disabled: _vm.disabled },
            on: { click: _vm.showForm }
          },
          [
            _c("i", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.bottom.hover",
                  value: _vm.$t("EDIT"),
                  expression: "$t('EDIT')",
                  modifiers: { bottom: true, hover: true }
                }
              ],
              staticClass: "typcn typcn-edit",
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v(" "),
            _c("span", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "EDIT",
                  expression: "'EDIT'"
                }
              ],
              staticClass: "hint-text-mobile"
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "action-icon" }, [
        _c(
          "a",
          {
            staticClass: "btn btn-list-function",
            attrs: { disabled: _vm.disabled },
            on: { click: _vm.onDelete }
          },
          [
            _c("i", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.bottom.hover",
                  value: _vm.$t("DELETE"),
                  expression: "$t('DELETE')",
                  modifiers: { bottom: true, hover: true }
                }
              ],
              staticClass: "typcn typcn-trash",
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v(" "),
            _c("span", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "DELETE",
                  expression: "'DELETE'"
                }
              ],
              staticClass: "hint-text-mobile"
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("ChangeLogObjectButtonAction", {
        attrs: {
          "is-disabled": _vm.disabled,
          "object-id": _vm.currentAddress.id,
          "object-name": _vm.currentAddress.incomingQueryStringName,
          "object-type": "Address"
        }
      }),
      _vm._v(" "),
      _vm.showPopOver
        ? _c(
            "ConfirmationModal",
            {
              ref: "modal",
              attrs: {
                title: _vm.$t("TITLE_DELETE"),
                "cancel-button-text": _vm.$t("CANCEL"),
                "confirm-action-text": _vm.$t("DELETE"),
                "show-header-close-button": false
              },
              on: { confirm: _vm.onConfirm, close: _vm.onCancel }
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.$t("DELETE_ADDRESS_MODAL_MESSAGE")) +
                  "\n  "
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }